import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with show/hide toggle (eye icon).
 * Drop-in replacement for raw <input type=password>.
 */
export default function PasswordInput({
    value, onChange, placeholder = "••••••••", required = true,
    autoComplete = "current-password", testid = "password-input",
    className = "",
}) {
    const [show, setShow] = useState(false);
    return (
        <div className="relative">
            <input
                type={show ? "text" : "password"}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                required={required}
                autoComplete={autoComplete}
                data-testid={testid}
                className={`w-full h-11 pl-4 pr-11 bg-slate-950 border border-slate-700 rounded text-white focus:outline-none focus:ring-2 focus:ring-[#00FF66] ${className}`}
            />
            <button
                type="button"
                onClick={() => setShow(s => !s)}
                aria-label={show ? "Hide password" : "Show password"}
                data-testid={`${testid}-toggle`}
                className="absolute inset-y-0 right-0 px-3 flex items-center text-slate-400 hover:text-[#00FF66]"
            >
                {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
        </div>
    );
}
